module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAD3SURBVHgB1ZShEoMwDIbTHQI5iUROTk5WTvIIPNIeZXKyEskjIJGTOJawBHrdXVqK2n+XA9L2S5qmACia57mEnTpFxhuEtl6AM9kRYIdWI6Tm7xbtpi0oQgdvs0KTTN5od/QP7Jvw/Up+Y8wQrjcBjKJbtNTaUbAOwd0PkKM2kKeXQP0aWsiXlY44cXY1bDXLUSnrJUMNNqL1EFflAzVR0Z/4fMD3EFSlABchlNqEoONR4NpC3FaVNrmABCCfoIXILfGBkzLHMijW7Et9ZctDBJpyc8YViMUmmIN8OWZsh8JXx8F+EcytnHCU/3cXiG+TMuols//RB1iLUXrmvlb0AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/image/new/game/game-tab2.png
// module id = ZxwK
// module chunks = 1